<div class="main-page-container">
  <!-- <div class="header-container">
    <img src="assets/Images/tgts/header.png" alt="" class="header-img">
  </div> -->
<div class="sticky-top" style="background-color: #fff;">
  <div class="">
    <div class="title-container padding-x">
      <p class="title mb-0">Create Itinerary</p>
    </div>

    <div class="navbar-list-container padding-x">
      <div class="item">
        <p class="link active">Trip Details</p>
      </div>
      <div class="item">
        <p class="link">AI Route Plan</p>
      </div>
      <div class="item">
        <p class="link">Hotels</p>
      </div>
      <div class="item">
        <p class="link">Vehicles</p>
      </div>
      <div class="item">
        <p class="link">Review</p>
      </div>
      <div class="item">
        <p class="link">Pricing</p>
      </div>
      <div class="item">
        <p class="link">Payment</p>
      </div>
      <div class="item">
        <p class="link">Confirmation</p>
      </div>
    </div>
  </div>

  <div class="days-form-container">
    <div class="padding-x">
      <form [formGroup]="tripDetailsForm">
        <div class="form-container">
          <div class="input-container">
            <label for="" class="label">No Of Days</label>
            <app-increment-number-input [max]="99" formControlName="days"></app-increment-number-input>
          </div>
          <div class="input-container">
            <label for="" class="label">Start Date</label>
            <app-date-picker [minDate]="today()" formControlName="startDate"></app-date-picker>
          </div>
          <div class="input-container">
            <label for="" class="label">Start Location</label>
            <app-locations-autocomplete [placeHolder]="'Enter Location'"
              formControlName="startLocation"></app-locations-autocomplete>
          </div>
          <div class="input-container">
            <label for="" class="label">End Location</label>
            <app-locations-autocomplete [placeHolder]="'Enter Location'"
              formControlName="endLocation"></app-locations-autocomplete>
          </div>
          <div class="input-container">
            <label for="" class="label">No Of Visitors</label>
            <app-no-of-guests-input formControlName="noOfGuests"></app-no-of-guests-input>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>

  <div class="padding-x">
    <div class="main-section-container">
      <div class="p-2">
        <div class="your-preference-container">
          <div class="">
            <div class="title-container border-bottom-1">
              <p class="fs-6 fw-bold mb-0">Your Preferences</p>
            </div>

            <form [formGroup]="preferencesForm">
              <!-- Interests -->
              <div>
                <div class="input-container">
                  <label class="label">Interests</label>
                </div>
                <div class="select-input-container" formGroupName="interests">
                  <div>
                    <input type="checkbox" id="Spiritual" class="checkbox-input" formControlName="Spiritual" />
                    <label for="Spiritual" class="checkbox-label">Spiritual</label>
                  </div>
                  <div>
                    <input type="checkbox" id="Heritage" class="checkbox-input" formControlName="Heritage" />
                    <label for="Heritage" class="checkbox-label">Heritage</label>
                  </div>
                  <div>
                    <input type="checkbox" id="Nature" class="checkbox-input" formControlName="Nature" />
                    <label for="Nature" class="checkbox-label">Nature</label>
                  </div>
                  <div>
                    <input type="checkbox" id="MedicalAndWellness" class="checkbox-input"
                      formControlName="MedicalAndWellness" />
                    <label for="MedicalAndWellness" class="checkbox-label">Wellness</label>
                  </div>
                  <div>
                    <input type="checkbox" id="Crafts" class="checkbox-input" formControlName="Crafts" />
                    <label for="Crafts" class="checkbox-label">Crafts</label>
                  </div>
                  <div>
                    <input type="checkbox" id="Waterfalls" class="checkbox-input" formControlName="Waterfalls" />
                    <label for="Waterfalls" class="checkbox-label">Waterfalls</label>
                  </div>
                </div>
              </div>

              <!-- Accessibility -->
              <div>
                <div class="input-container">
                  <label class="label">Accessibility</label>
                </div>
                <div class="select-input-container" formGroupName="accessibility">
                  <div>
                    <input type="checkbox" id="WheelchairFriendly" class="checkbox-input"
                      formControlName="WheelchairFriendly" />
                    <label for="WheelchairFriendly" class="checkbox-label">Wheelchair-friendly</label>
                  </div>
                  <div>
                    <input type="checkbox" id="LowWalking" class="checkbox-input" formControlName="LowWalking" />
                    <label for="LowWalking" class="checkbox-label">Low-walking</label>
                  </div>
                  <div>
                    <input type="checkbox" id="SeniorFriendly" class="checkbox-input"
                      formControlName="SeniorFriendly" />
                    <label for="SeniorFriendly" class="checkbox-label">Senior friendly</label>
                  </div>
                </div>
              </div>

              <!-- Food preference -->
              <div>
                <div class="input-container">
                  <label class="label">Food preference</label>
                </div>
                <div class="select-input-container" formGroupName="foodPreference">
                  <div>
                    <input type="checkbox" id="VegOnly" class="checkbox-input" formControlName="VegOnly" />
                    <label for="VegOnly" class="checkbox-label">Veg Only</label>
                  </div>
                  <div>
                    <input type="checkbox" id="VegNonVeg" class="checkbox-input" formControlName="VegNonVeg" />
                    <label for="VegNonVeg" class="checkbox-label">Veg+NonVeg</label>
                  </div>
                  <div>
                    <input type="checkbox" id="Vegan" class="checkbox-input" formControlName="Vegan" />
                    <label for="Vegan" class="checkbox-label">Vegan</label>
                  </div>
                </div>
              </div>

              <!-- Climate / Comfort preference -->
              <div>
                <div class="input-container">
                  <label class="label">Comfort preference</label>
                </div>
                <div class="select-input-container" formGroupName="comfortPreference">
                  <div>
                    <input type="checkbox" id="AvoidHeat" class="checkbox-input" formControlName="AvoidHeat" />
                    <label for="AvoidHeat" class="checkbox-label">Avoid heat</label>
                  </div>
                  <div>
                    <input type="checkbox" id="Comfortable" class="checkbox-input" formControlName="Comfortable" />
                    <label for="Comfortable" class="checkbox-label">Comfortable</label>
                  </div>
                  <div>
                    <input type="checkbox" id="Any" class="checkbox-input" formControlName="Any" />
                    <label for="Any" class="checkbox-label">Any</label>
                  </div>
                </div>
              </div>
            </form>
            <hr>
          </div>
        </div>
      </div>
      
      <div>
        <div class="d-flex justify-content-between mt-2">
          <p class="title fw-bold fs-6 mb-0">Suggested Place Base on Your Preferences</p>

          <div>
            <input type="text" class="main-search-bar" placeholder="Search & Add Destination">
          </div>
        </div>
        <div class="wrapper">

          <div class="location-block" *ngFor="let loc of locations">

            <!-- Location Header -->
            <div class="location-header">
              <span class="location-title">{{ loc.location }}</span>

              <div class="location-actions">
                <button (click)="addLocation()">Add Location</button>
                <button (click)="toggleSelectAll(loc)">
                  {{ isAllSelected(loc) ? 'Unselect All' : 'Select All' }}
                </button>
              </div>
            </div>

            <!-- Places Grid -->
            <div class="places-grid">
              <div class="place-card" *ngFor="let place of loc.places">

                <input type="checkbox" [checked]="place.selected" (change)="togglePlace(place)" />

                <div class="icon" [ngClass]="{
            'fort': place.category === 'fort',
            'temple': place.category === 'temple'
          }">
                  <span *ngIf="place.category === 'fort'"><img src="assets/Images/tgts/heritage-icon.png"
                      class="category-icon" alt=""></span>
                  <span *ngIf="place.category === 'temple'"><img src="assets/Images/tgts/temple-icon.png"
                      class="category-icon" alt=""></span>
                </div>

                <div class="place-info">
                  <div class="place-name">{{ place.name }}</div>
                  <div class="place-duration">
                    Estimated Visit Hours - {{ place.duration }}
                  </div>
                </div>

              </div>
            </div>

            <hr />
          </div>
        </div>
      </div>
    </div>
    <div class="footer-main-container">
    <div class="d-flex justify-content-center">
      <ion-button class="filled-blue-btn submit-btn" (click)="onSubmit()">Build My Itinerary</ion-button>
    </div>
    </div>
  </div>

  <app-spinner *ngIf="showSpinner"></app-spinner>
</div>